import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import DataBlock from '../../../common/DataBlock'
import DataOnLyFinancialAnalysis from '../../../common/DataOnLyFinancialAnalysis'
import ItemsInformation from '../../../common/ItemsInformation'
import Subtotal from '../../../common/Subtotal'
import { LANGUAGE } from '../../../constant'
import { handleUnitReport } from '../../../helper'
import { selectFactSheetDetail } from '../../../store/slice'
import classes from '../../../index.module.scss'

const ItemFactSheet = ({ id, index }) => {
  const detail = useSelector(selectFactSheetDetail(id))

  return (
    <>
      <Element
        style={{ borderTop: index ? '1px dashed #D5D5D5' : undefined }}
        className={`${classes.headerItem}`}
      >
        <Element style={{ color: '#0553A5' }} className="fw600">
          {detail?.companyName}
        </Element>
      </Element>
      <div className="pl3">
        {!detail.isOnlyFinancialStatement ? (
          <DataBlock isOrderInformation detail={detail} />
        ) : (
          <DataOnLyFinancialAnalysis isOrderInformation detail={detail} />
        )}
        <ItemsInformation
          data={[
            {
              title: 'cartAndOrders.main.language',
              value: (
                <Translate
                  value={`cartAndOrders.main.${
                    detail.language === LANGUAGE.EN ? 'ENGLISH' : 'VIETNAMESE'
                  }`}
                />
              ),
            },
            { title: 'cartAndOrders.main.currency', value: detail.currency },
            {
              title: 'cartAndOrders.main.unit',
              value: handleUnitReport(detail.unit),
            },
          ]}
        />
        <ItemsInformation
          data={[
            {
              title: 'cartAndOrders.main.additional',
              value: detail.additionalCurrency,
            },
            {
              title: 'cartAndOrders.main.unit',
              value: handleUnitReport(detail.additionalUnit),
            },
          ]}
        />
        <Subtotal value={detail.subPrice} isSub={!!detail.discountPercentage} />
      </div>
    </>
  )
}

export default ItemFactSheet
